import {createSimpleAction} from "../../utils/actionUtils";

export const LOAD_MANAGE_PROJEKTE = 'LOAD_MANAGE_PROJEKTE'
export const loadMangedProjekteAction = createSimpleAction(LOAD_MANAGE_PROJEKTE, 'pageParameters')

export const LOAD_MANAGE_PROJEKTE_SUCCESS = 'LOAD_MANAGE_PROJEKTE_SUCCESS'
export const loadMangedProjekteActionSuccess = createSimpleAction(LOAD_MANAGE_PROJEKTE_SUCCESS, 'page')